// extracted by mini-css-extract-plugin
export default {"resultContainer":"Result_resultContainer__pFfxb","textContainer":"Result_textContainer__Z0sSw","registrationCode":"Result_registrationCode__+JIFF"};